import React, { useState, useEffect, useRef } from "react";

//routes
import { useHistory, useParams } from "react-router-dom";

import { motion } from "framer-motion";

//scroll
import VirtualScroll from "virtual-scroll";
import LocomotiveScroll from "locomotive-scroll";

// check is mobile
import { isMobile } from "react-device-detect";

//data
import { titles } from "../assets/data/titles";
import { chapterMenu } from "../assets/data/chapterMenu";

import { lerp } from "../utils/math";
import Chapter01 from "./chapters/chapter01";
import Chapter02 from "./chapters/chapter02";
import Chapter03 from "./chapters/chapter03";
import Chapter04 from "./chapters/chapter04";
import Chapter05 from "./chapters/chapter05";
import Chapter06 from "./chapters/chapter06";
import Chapter07 from "./chapters/chapter07";
import Chapter08 from "./chapters/chapter08";
import Chapter09 from "./chapters/chapter09";
import Chapter10 from "./chapters/chapter10";

import {
  useGlobalDispatchContext,
  useGlobalStateContext,
} from "../context/globalContext";

const factor = window.innerWidth >= 2560 ? 2 : 1;

const Chapter = () => {
  let { id } = useParams();
  let history = useHistory();
  const i = parseInt(id, 10) - 1;
  const [entered, setEntered] = useState(false);
  const [onLoaded, setOnloaded] = useState(false);
  const scrollRef = useRef();
  const scroll = useRef();
  const { cursorStyles, hiddenNav } = useGlobalStateContext();
  const dispatch = useGlobalDispatchContext();
  const hiddenNavRef = useRef(false);

  useEffect(() => {
    hiddenNavRef.current = hiddenNav;
  }, [hiddenNav]);

  useEffect(() => {
    setTimeout(() => {
      scroll.current = new LocomotiveScroll({
        el: scrollRef.current,
        smooth: true,
        tablet: { smooth: true, direction: "vertical" },
        smartphone: { smooth: true, direction: "vertical" },
      });

      dispatch({ type: "CURSOR_TYPE", cursorType: false });

      scroll.current.on("scroll", (args) => {
        if (args.scroll.y > 690) {
          if (!hiddenNavRef.current) {
            dispatch({ type: "HIDDEN_NAV", hiddenNav: true });
          }
        } else if (args.scroll.y <= 690) {
          if (hiddenNavRef.current) {
            dispatch({ type: "HIDDEN_NAV", hiddenNav: false });
          }
        }
        if (args.scroll.y === args.limit.y) {
          dispatch({ type: "HIDDEN_NAV", hiddenNav: false });
          history.push("/");
        }
      });
    }, 2000);

    return () => {
      scroll.current.destroy();
    };
  }, []);

  const onCursor = (cursorType) => {
    cursorType = (cursorStyles.includes(cursorType) && cursorType) || false;
    dispatch({ type: "CURSOR_TYPE", cursorType: cursorType });
  };

  useEffect(() => {
    if (scroll.current) {
      if (entered) {
        onCursor("drag");
        scroll.current.stop();
      } else {
        onCursor(null);
        scroll.current.start();
      }
    }
  }, [entered]);

  return (
    <motion.div exit={{ opacity: 0 }} id="chapter">
      <div ref={scrollRef}>
        <div className="chapter-img">
          <motion.div
            initial={{ top: "150%" }}
            animate={{ top: onLoaded ? "50%" : "150%" }}
            transition={{ duration: 1, ease: [0, 0.89, 0.14, 0.93] }}
            className="images"
          >
            <motion.img
              onLoad={() => setOnloaded(true)}
              src={titles[i].imageH}
              transition={{ duration: 1, ease: "easeOut" }}
              layoutId={id}
              style={{
                objectPosition: `0 ${titles[i].y / 0.375}rem`,
              }}
              alt=""
            />
          </motion.div>
        </div>
        <Titles entered={entered} setEntered={setEntered} id={id} />

        <div className="body-section">
          {i === 0 && <Chapter01 />}
          {i === 1 && <Chapter02 />}
          {i === 2 && <Chapter03 />}
          {i === 3 && <Chapter04 />}
          {i === 4 && <Chapter05 />}
          {i === 5 && <Chapter06 />}
          {i === 6 && <Chapter07 />}
          {i === 7 && <Chapter08 />}
          {i === 8 && <Chapter09 />}
          {i === 9 && <Chapter10 />}
        </div>
        <div className="blank"></div>
      </div>
    </motion.div>
  );
};

const Titles = ({ id, setEntered, entered }) => {
  let history = useHistory();
  const scrollContainer = useRef();
  const direction = useRef(1);
  const requestRef = useRef(); //requestAnimation way
  var scroll = useRef(null);
  const titlesSection = useRef();
  const titlesRef = useRef([]);
  const enteredRef = useRef(false);
  const state = useRef({
    bounds: {},
    current: 0,
    last: 0,
    dragStart: 0,
    dragEnd: 0,
    dragging: false,
  });

  const options = useRef({
    ease: 0.1,
    dragSpeed: 1.5,
  });

  const smooth = () => {
    changeXPositions();
    state.current.last = lerp(
      state.current.last,
      state.current.current,
      options.current.ease
    );
    if (state.current.current < state.current.last && direction.current !== 1) {
      direction.current = 1;
    }
    if (
      state.current.current > state.current.last &&
      direction.current !== -1
    ) {
      direction.current = -1;
    }
    if (scrollContainer.current)
      scrollContainer.current.style.transform = `translateX(${state.current.last}px)`;

    requestRef.current = requestAnimationFrame(smooth); //way requestAnimation
  };

  const changeXPositions = () => {
    titlesRef.current.map((el) => {
      if (el) {
        const measures = el.getBoundingClientRect();

        let displace = 194 + chapterMenu[parsedId - 1].space / 2; //300
        if (factor > 1) displace *= factor - 0.1; //big screen

        if (direction.current === 1) {
          if (measures.x + measures.width < 0) {
            el.style.left = `${parseInt(el.style.left, 10) + displace}rem`;
          }
        } else {
          if (measures.x > window.innerWidth)
            el.style.left = `${parseInt(el.style.left, 10) - displace}rem`;
        }
      }
    });
  };

  useEffect(() => {
    scroll.current = new VirtualScroll({
      el: titlesSection.current,
      useTouch: true,
      mouseMultiplier: 0.4,
      useKeyboard: true,
    });
    addListeners();
    scroll.current.on(calc);

    requestRef.current = requestAnimationFrame(smooth); // requestAnimation way

    const i = parseInt(id, 10) - 1;

    setTimeout(() => {
      state.current.current =
        -titlesRef.current[i].getBoundingClientRect().left + 50;
    }, 600);

    return () => {
      removeListeners();
      cancelAnimationFrame(requestRef.current); //requestAnimation way
      scroll.current.destroy();
    };
  }, []);

  useEffect(() => {
    enteredRef.current = entered;
  }, [entered]);

  const addListeners = () => {
    //check if is not mobile

    window.addEventListener("mouseup", handleMouseup);
    window.addEventListener("mousedown", handleMousedown);
    window.addEventListener("mouseleave", handleMouseup);
    window.addEventListener("mousemove", handleMousemove);
  };

  const removeListeners = () => {
    //check if is not mobile
    if (titlesSection.current) {
      window.removeEventListener("mouseup", handleMouseup);
      window.removeEventListener("mousedown", handleMousedown);
      window.removeEventListener("mouseleave", handleMouseup);
      window.removeEventListener("mousemove", handleMousemove);
    }
  };

  const handleMouseup = () => {
    if (enteredRef.current) {
      state.current.dragging = false;
      state.current.dragEnd = state.current.current;

      document.body.classList.remove("is-dragging");
    }
  };

  const handleMousedown = (e) => {
    if (enteredRef.current) {
      state.current.dragging = true;

      state.current.dragEnd = state.current.current;
      state.current.dragStart = e.clientX;

      document.body.classList.add("is-dragging");
    }
  };

  const handleMousemove = (e) => {
    if (enteredRef.current) {
      if (!state.current.dragging) return;

      state.current.current =
        state.current.dragEnd +
        (e.clientX - state.current.dragStart) * options.current.dragSpeed;
    }
  };

  const calc = (e) => {
    //mobile ***
    if (isMobile) {
      state.current.current += e.deltaX;
    } else {
      state.current.current += e.deltaY;
    }
  };

  const selectedStyle = (title) => {
    let multiplicator = 1;
    if (factor > 1) {
      multiplicator = factor - 0.5;
    }
    return `${
      Math.min(Math.max(3 * (10 / title.text.split(" ").length), 6), 8) *
      multiplicator
    }rem`;
  };

  const parsedId = parseInt(id);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { delay: 0.6 } }}
      onMouseEnter={() => setEntered(true)}
      onMouseLeave={() => setEntered(false)}
      ref={titlesSection}
      className="titles-section"
    >
      <div ref={scrollContainer} className="scroll-section">
        {chapterMenu.map((title, i) => (
          <div
            onClick={() => {
              if (!state.current.dragging) history.push(`/chapter/${title.id}`);
            }}
            key={title.id}
            ref={(element) => (titlesRef.current[i] = element)}
            style={{
              left: `${
                i < parsedId
                  ? title.x * factor
                  : title.x * factor + chapterMenu[parsedId - 1].space
              }rem`,
              fontSize: title.id === id ? selectedStyle(title) : null,
            }}
            className={`title ${title.id === id ? "selected" : ""}`}
          >
            {title.text}
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default Chapter;
